import { NotFoundPage } from '@denqfabrik/landing-ui';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/i18n';

export default function AppNotFoundPage() {
  const { t } = useTranslation();
  useDocumentTitle({ title: 'Page Not Found' });
  const notFound = t.notFound as { title: string; description: string; backHome: string };
  return (
    <NotFoundPage
      title={notFound.title}
      description={notFound.description}
      backLabel={notFound.backHome}
      backTo="/"
    />
  );
}
